import React, {Component} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {bindActionCreators} from "redux";
import {searchStockTakeProducts} from "./actions";
import ListView from "../common/ListView";
import {Button} from "antd";
import {Link} from "react-router-dom";
import {decodeParams} from "../utils/params";

class StockTakeUncountedPage extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    /* state */
    searchProducts: PropTypes.object.isRequired,
    /* actions */
    searchStockTakeProducts: PropTypes.func.isRequired,
  };

  render() {
    const {
      history, searchStockTakeProducts,
      searchProducts: {searching, pagination, filters, sorter, searchFilter, results},
      match: {params},
    } = this.props;
    const {stockTakeId} = decodeParams(params);
    const columns = [
      {
        title: 'Product',
        dataIndex: 'productDisplay',
        key: 'productDisplay',
        sorter: true,
      },
      {
        title: 'SKU',
        dataIndex: 'sku',
        key: 'sku',
        sorter: true,
      },
      {
        title: 'Action',
        key: 'action',
        render: (_, {stockTakeId, sku}) => <Link to={`/stock-take/take/${encodeURIComponent(stockTakeId)}/${encodeURIComponent(sku)}`}>Count</Link>
      }
    ];
    return (
      <ListView
        title={[
          <Button key="back" icon="arrow-left" onClick={() => history.goBack()} />,
          " Uncounted"
        ]}
        loading={searching}
        columns={columns}
        dataSourceProvider={(payload) => searchStockTakeProducts({...payload, filters: {...payload.filters, counted: false, stockTakeId}})}
        dataSource={results}
        pagination={pagination}
        searchFilter={searchFilter}
        filters={filters}
        sorter={sorter}
        rowKey={record => record.productId + record.sku}
      />
    );
  }
}

const mapStateToProps = state => ({
  loading: state.stockTake.stockTakesLoading,
  searchProducts: state.stockTake.searchProducts,
});

const mapDispatchToProps = dispatch => (bindActionCreators({
  searchStockTakeProducts,
}, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(StockTakeUncountedPage);



// WEBPACK FOOTER //
// ./src/StockTake/StockTakeUncountedPage.js